// ─────────────────────────────────────────────────────────────────────────────
// Five Lights Reno — company facts
// ─────────────────────────────────────────────────────────────────────────────
// Every value here is something the business has actually published (site
// footer/contact page, or its own Instagram profile). Nothing is inferred or
// filled in to look complete.
//
// DELIBERATELY ABSENT — do not add without the owner confirming:
//   • street address        (service-area business; only the city is public)
//   • opening hours         (never stated anywhere)
//   • years in business / founding year
//   • licence or insurance numbers
//   • customer reviews or ratings   (see `testimonials` below)
// These also stay out of the structured data in seo/schema.js, because
// asserting an unconfirmed fact there is worse than omitting it.

export const COMPANY = {
  name: "Five Lights Reno",
  legalName: "Five Lights Reno",
  tagline: "Renovations done right, start to finish.",

  // Both numbers are published on the current site and on the company's own
  // Instagram marketing posts. `primary` is the one used for tel: CTAs.
  phone: {
    primary: "647-606-9228",
    secondary: "647-702-2132",
    primaryE164: "+16476069228",
    secondaryE164: "+16477022132",
  },

  email: "Fivelightsreno@hotmail.com",

  // City only — there is no confirmed street address to publish.
  address: {
    locality: "Pickering",
    region: "ON",
    regionName: "Ontario",
    country: "CA",
    countryName: "Canada",
    display: "Pickering, Ontario",
  },

  // Owner-confirmed channels only. Facebook is intentionally missing: the
  // business is said to use one, but no verified Page URL has been supplied.
  social: [
    { label: "Instagram", href: "https://www.instagram.com/fivelightsreno" },
    { label: "Pinterest", href: "https://www.pinterest.com/fivelightsreno/" },
    { label: "TikTok", href: "https://www.tiktok.com/@fivelightsreno" },
  ],

  // Figure carried over from the existing site, where the business states it.
  // Presented as the company's own claim, never dressed up as a verified stat.
  projectsCompleted: "150+",
};

// Cities with a dedicated landing page, in the order they appear in nav and
// footer. `slug` is the route; keep in sync with data/locations.js and the
// sitemap generator.
export const SERVICE_AREAS = [
  { name: "Pickering", slug: "pickering" },
  { name: "Ajax", slug: "ajax" },
  { name: "Whitby", slug: "whitby" },
  { name: "Durham Region", slug: "durham-region" },
];

// Additional communities the business names as served on the current site.
// Mentioned in copy and areaServed, but with no dedicated page — there isn't
// enough distinct, truthful content to justify one for each.
export const ALSO_SERVED = ["Oshawa", "Scarborough", "Toronto"];

// ── Testimonials ────────────────────────────────────────────────────────────
// Intentionally empty. No verified customer reviews have been supplied, and
// inventing them would be a fabricated-review problem, not a copy problem.
//
// To turn the section on, push objects of this shape and it renders
// automatically — no component changes needed:
//   { quote: "…", name: "First L.", location: "Ajax, ON", project: "Bathroom" }
//
// Until then <Testimonials /> falls back to the working-commitments block,
// which is labelled as commitments rather than dressed up as reviews. Review
// structured data (AggregateRating/Review) stays off while this is empty.
export const TESTIMONIALS = [];
